<template>
  <ul>
    <li v-for="(cont, idx) in content" :key="idx">
      <JiraCommentBlock :type="cont.type as CommentContentType">
        •
        <span v-for="(contentWithin, i) in cont.content" :key="i">
          <span v-if="contentWithin.type === ContentType.TEXT">
            {{ contentWithin.text }}
          </span>
          <span v-else-if="contentWithin.type === ContentType.MEDIA">
            <em>See attachments</em>
          </span>
          <span v-else-if="contentWithin.type === ContentType.INLINE_CARD">
            <SoLink
              :text="contentWithin.attrs.url"
              :href="contentWithin.attrs.url"
            />
          </span>
          <SoMention v-else-if="contentWithin.type === ContentType.MENTION">
            {{ contentWithin.attrs.text }}
          </SoMention>
          <span v-else-if="contentWithin.type === ContentType.HARD_BREAK">
            <br />
          </span>
          <span v-else-if="contentWithin.type === ContentType.HEADING">
            <strong>
              {{ contentWithin.content.text }}
            </strong>
          </span>
        </span>
      </JiraCommentBlock>
    </li>
  </ul>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import JiraCommentBlock from "@/views/customer/issues/components/JiraCommentBlock.vue"
  import SoLink from "@/components/SoLink.vue"
  import {
    CommentContentType,
    ContentInWithinInnerType,
    ContentType,
  } from "@/models/jiraIssue/jiraIssue.types"
  import SoMention from "@/components/SoMention.vue"

  export default defineComponent({
    components: { SoMention, SoLink, JiraCommentBlock },
    props: {
      content: {
        type: Array as PropType<ContentInWithinInnerType[]>,
        default: [] as ContentInWithinInnerType[],
        required: true,
      },
    },
    computed: {
      CommentContentType() {
        return CommentContentType
      },
      ContentType() {
        return ContentType
      },
    },
  })
</script>
